module.exports = __webpack_public_path__ + "static/media/Inter-ExtraBoldItalic.027e59f6.woff";